import axios from 'axios'
export default () => {
  return axios.create({
    baseURL: 'https://amo.konovalov.biz/api'
  })
}   